/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

export default mapToArray;



//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/~/lodash-es/_mapToArray.js
// module id = 3462
// module chunks = 0